import { useMemo } from 'react';

import dateService from '@gem/services/date-service';

export function useSharedVoicePlayerPresenter(serverTime: number): string {
  return useMemo(() => {
    return (
      dateService.format(serverTime, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }) || ''
    );
  }, [serverTime]);
}
